import {
  Directive,
  ElementRef,
  input,
  OnChanges,
  OnInit,
  inject,
} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[gstarPrimeGridRowAccordion]',
})
export class PrimeGridRowAccordionDirective implements OnInit, OnChanges {
  private readonly elementRef = inject<ElementRef<HTMLDivElement>>(ElementRef);

  gstarPrimeGridRowAccordion = input<boolean>(false);
  isRowDisabled = input<boolean>(false);
  cellKey = input<string>('');
  cellsToExpand = input<string[]>([]);

  private previousExpanded = false;

  ngOnInit(): void {
    this.updateClass();
  }

  ngOnChanges(): void {
    const isCurrentExpanded = this.gstarPrimeGridRowAccordion();
    if (isCurrentExpanded !== this.previousExpanded) {
      this.previousExpanded = isCurrentExpanded;
      this.updateClass();
    }
  }

  private updateClass(): void {
    if (!this.cellsToExpand().includes(this.cellKey())) {
      return;
    }
    const rect = this.elementRef.nativeElement.getBoundingClientRect();
    this.elementRef.nativeElement.style.width = `${rect.width}px`;
    if (!this.isRowDisabled()) {
      if (this.gstarPrimeGridRowAccordion()) {
        this.elementRef.nativeElement.classList.remove('collapsed');
      } else {
        this.elementRef.nativeElement.classList.add('collapsed');
      }
    }
  }
}
